import "./UserDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import UserDetailsViewComponent from "./user-details-view/UserDetailsViewComponent";
import UserDetailsEditComponent from "./user-details-edit/UserDetailsEditComponent";

interface UserDetailsViewEditComponentProps {
    onUpdateUserInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
    userDetails: any;
}

const UserDetailsViewEditComponent = (props: UserDetailsViewEditComponentProps) => {

    const {userDetails, onUpdateUserInformation, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [patientBasicInformation, setPatientBasicInformation] = useState<any>(undefined);

    const handlePatientBasicInformationUpdate = useCallback((updatedPatientInformation: any) => {
        onUpdateUserInformation(updatedPatientInformation);
        setMode("view");
    }, [onUpdateUserInformation]);

    const handlePatientBasicInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (userDetails) {
            setPatientBasicInformation(userDetails);
        }
    }, [userDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange]);

    return (
        <div className={'user-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <UserDetailsViewComponent
                    userDetails={patientBasicInformation}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <UserDetailsEditComponent
                    userDetails={patientBasicInformation}
                    onUpdateComplete={handlePatientBasicInformationUpdate}
                    onEditCancel={handlePatientBasicInformationEditCancel}
                />
            }
        </div>
    );

};

export default UserDetailsViewEditComponent;